// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#RemindInfo[data-v-2105f334]{color:#333;font-size:14px;line-height:30px}", ""]);
// Exports
module.exports = exports;
